import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { OnlinePhotoOrderComponent } from './online-photo-order/online-photo-order.component';
import { ProductComponent } from './product/product.component';
import { CartComponent} from './cart/cart.component';
import { PhotoSelectionComponent } from './photo-selection/photo-selection.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyordersComponent } from './myorders/myorders.component';
import { OrderdetailComponent } from './orderdetail/orderdetail.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { OrderProcessingComponent } from './order-processing/order-processing.component';
import { AuthGuard } from './auth/auth.guard';
import {VerifyUserComponent} from './verify-user/verify-user.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import {MakePaymentEftComponent} from './make-payment-eft/make-payment-eft.component';
import {NewphotoselectionComponent} from "./newphotoselection/newphotoselection.component"; 
import { JobPhotoSelectionComponent } from './job-photo-selection/job-photo-selection.component';
import { JobphotosproductsComponent } from './jobphotosproducts/jobphotosproducts.component';
import { SessionLoginComponent } from './session-login/session-login.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'online-photo-order',
        component: OnlinePhotoOrderComponent,
    },
    {
        path: 'product/:jobid',
        component: ProductComponent,
    },
    {
        path: 'cart',
        component: CartComponent,
    },
    {
        path: 'photoselection',
        component: PhotoSelectionComponent,
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'home',
        component: HomeComponent,
    },
    {
        path: 'myorders',
        component: MyordersComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'orderdetail/:order_id/:is_transcation',
        component: OrderdetailComponent
    },
    {
        path: 'changepassword',
        component: ChangePasswordComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'orderprocessing',
        component: OrderProcessingComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'forgetpassword',
        component: ForgetPasswordComponent
    },
    {
        path: 'verifyuser',
        component: VerifyUserComponent
    },
    {
        path: 'makepayment',
        component: MakePaymentComponent
    },
    {
        path: 'makepaymenteft',
        component: MakePaymentEftComponent
    },
    {
        path: 'newphotoselection',
        component: NewphotoselectionComponent
    },
    {
        path: 'jobphotoselection/:jobid',
        component: JobPhotoSelectionComponent
    },
    {
        path: 'jobpphotosproducts',
        component: JobphotosproductsComponent
    },
    {
        path: 'login',
        component: SessionLoginComponent,
    },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/app-routing.module.ts